<template>
  <div :class="content.type != null ? 'card-' + content.type : 'card-group'">
    <div v-for="titreSection in cartes" :key="titreSection['id']">
      <CarteObsolete :content="titreSection" :metadata="titreSection"></CarteObsolete>
    </div>
  </div>
</template>

<script>
import CarteObsolete from '@/components/base/CarteObsolete';

export default {
  name: 'GroupeCarte',
  components: {
    CarteObsolete,
  },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      cartes: [],
      cardNodes: this.content.carte['@nodes'],
    };
  },
  created() {
    for (let i = 0; i < this.cardNodes.length; i++) {
      this.cartes.push(this.content.carte[this.cardNodes[i]]);
    }
  },
};
</script>
